// extracted by mini-css-extract-plugin
export var chip = "_e6-0";
export var filterDropdown = "_e6-5";
export var filterItem = "_e6-6";
export var icon = "_e6-1";
export var removeButton = "_e6-3";
export var removeIcon = "_e6-4";
export var separator = "_e6-2";